import React from "react";
import PolicyLayout from "../PolicyLayout";

const RiskManagementPolicy: React.FC = () => {
  const policySections = [
    {
      title: `1. ${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `1.1 The Board of Directors (“Board”) of ${import.meta.env.VITE_COMPANY_NAME} (“Company”) has adopted the following policy, encompassing practices relating to identification, assessment, monitoring, and mitigation of various business risks.

1.2 The Risk Management Policy (“Policy”) aims to minimize unfavorable impacts on business objectives and enhance stakeholder value. It is also designed to sustain and strengthen the Company’s long-term competitive advantage.`,
    },
    {
      title: "2. Purpose",
      content: `2.1 This Policy has been framed in accordance with the Risk Management Framework issued by the Reserve Bank of India (RBI) vide Master Direction DNBR. PD. 008/03.10.119/2016-17 dated September 1, 2016, and subsequent amendments.

2.2 The Policy aims to address potential losses to the Company’s human and financial assets while maintaining flexibility in pursuing growth-oriented activities that align with the Company's goals.`,
    },
    {
      title: "3. Principles",
      list: [
        "Risk management must create and protect value.",
        "It must be integrated into organizational processes.",
        "It supports informed decision-making.",
        "It focuses on uncertainties surrounding objectives.",
        "It must be tailored to the business context.",
        "It must be dynamic, iterative, and responsive to change.",
      ],
    },
    {
      title: "4. Definitions",
      list: [
        "Board: Board of Directors of the Company.",
        `Company: ${import.meta.env.VITE_COMPANY_NAME}.`,
        "Directors: Members of the Board.",
        "Policy: Risk Management Policy.",
        "RBI: Reserve Bank of India.",
      ],
    },
    {
      title: "5. Policy Objectives",
      list: [
        "Continuously identify organizational risks affecting business operations.",
        "Safeguard shareholder rights and value through a comprehensive risk management framework.",
        "Enhance and maintain tools and processes to support strategic and operational decision-making.",
      ],
    },
    {
      title: "6. Risk Identification, Measurement, and Assessment",
      content: `6.1 Management, under the Board’s oversight, is responsible for implementing the Risk Management Program and risk identification processes.

6.2 Risks are measured through qualitative and quantitative methods based on likelihood and impact.

6.3 Risks are categorized into inherent and residual types depending on their potential effect.

6.4 Key Risk Categories Identified:`,
      list: [
        "Strategic Risk",
        "Operational Risk",
        "Market Risk",
        "Financial Risk",
        "Credit & Concentration Risk",
        "Regulatory & Compliance Risk",
        "Human Resource Risk",
      ],
    },
  ];

  return (
    <PolicyLayout 
      title="Risk Management" 
      subtitle={`At ${import.meta.env.VITE_COMPANY_NAME}, our risk management framework ensures early identification, assessment, and mitigation of business risks to protect institutional value.`}
      badge="Strategic Oversight 🛡️"
    >
      {policySections.map((section, idx) => (
        <div key={idx} className="space-y-6">
          <h2 className="text-3xl font-black text-[#0F172A] tracking-tight">
            {section.title}
          </h2>

          {section.content && (
            <p className="text-[var(--text-secondary)] text-lg leading-relaxed font-medium whitespace-pre-line">
              {section.content}
            </p>
          )}
          
          {section.list && (
            <ul className="space-y-4">
              {section.list.map((li, i) => (
                <li key={i} className="flex items-start gap-3 text-[var(--text-secondary)] text-lg font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--primary)] mt-2.5 flex-shrink-0" />
                  {li}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </PolicyLayout>
  );
};

export default RiskManagementPolicy;
